import React, { useState, useRef } from "react";
import styled from "styled-components";
import { Button, Form, Input, message, InputRef } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import SubmitButton from "ui/components/base/Buttons/SubmitButton";
import HeroImg from "images/enterprise/hero.png";
import AboutImg from "images/enterprise/aboutimg.jpg";
import Workbest from "images/enterprise/workbest.png";
import Alligned from "images/enterprise/alligned.png";
import Celebrate from "images/enterprise/celebrate.png";
import Shake from "images/enterprise/shakehands.png";
import Growth from "images/enterprise/growth.png";
import Loyalty from "images/enterprise/loyalty.png";
import { ReactComponent as Call } from "images/enterprise/call.svg";
import { ReactComponent as Mail } from "images/enterprise/mail.svg";
import { ReactComponent as PointIcon } from "images/enterprise/Group28.svg";
import { ReactComponent as Watermark1 } from "images/enterprise/leadership4.svg";
import { ReactComponent as Watermark2 } from "images/enterprise/mingcute_celebrate-fill.svg";
import { ReactComponent as Watermark3 } from "images/enterprise/dependable3.svg";
import { ReactComponent as Watermark4 } from "images/enterprise/teamwork1.svg";
import { ReactComponent as Watermark5 } from "images/enterprise/loyal-customer1.svg";
import { ReactComponent as Arrow } from "images/enterprise/arrow-right-02.svg";

const { TextArea } = Input;

const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_FORM_EMAIL;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div``;

const Hero = styled.div`
  background-image: url(${HeroImg});
  background-size: cover;
  background-position: center;
  height: 500px; /* Set your desired height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: white;
  gap: 2rem;
  text-align: center;
`;

const Header = styled.h2`
  text-align: center;
  margin: 0;
  font-size: 52px;
  font-weight: 700;
  line-height: 72px;
  @media (max-width: 1000px) {
    font-size: 35px;
    line-height: 50px;
  }
`;

const SmallText = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
`;

const GetStarted = styled(Button)`
  border-radius: 20px;
  width: 186px;
  background-color: #1390e6;
  color: #ffffff;
  border: 1.5px solid #ffffff;
  height: 55px;
  font-size: 20px;
  font-weight: 600;
  line-height: 150%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const GetStarted2 = styled(Button)`
  border-radius: 20px;
  width: 186px;
  background-color: #1390e6;
  color: #ffffff;
  border: 1.5px solid #ffffff;
  height: 55px;
  font-size: 20px;
  font-weight: 600;
  line-height: 150%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const About = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10%;
  justify-content: space-between;
  @media (max-width: 1000px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const AboutLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: start;
`;

const AboutRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 361px;
    height: 330px;
    border-radius: 50px;
  }
`;

const SectionHeader = styled.h2`
  text-align: center;
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 100%;
`;

const SectionText = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 36px;
`;

const CardText = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  text-align: left;
`;

const Whatwe = styled.div`
  background-color: #eaf6ff;
`;

const WhatweBottom = styled.div`
  text-align: center;
`;

const WhatweContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 6%;
  margin-bottom: 6%;
  margin-left: 10%;
  margin-right: 10%;
  align-items: center;
  justify-content: center;
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(381px, 1fr));
  gap: 2rem;
  width: 100%;
  margin-top: 2rem;
`;

const CardContainer2 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 381px);
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
  width: 100%;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    justify-content: center;
    width: 100%;
  }
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  text-align: center;
  height: 180px;
  display: flex;
  flex-direction: column;
  grid-area: 0.5rem;
  gap: 1rem;
  position: relative;
`;

const WatermarkContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`;

const Whowe = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10%;
  justify-content: space-between;
  @media (max-width: 1000px) {
    flex-direction: column-reverse;
    gap: 2rem;
  }
`;

const WhoweRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: start;
`;

const WhoweLeft = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 361px;
    height: 330px;
    border-radius: 50px;
  }
`;

const WhyIt = styled.div`
  background-color: #eaf6ff;
`;

const WhyItContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 6%;
  margin-bottom: 6%;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  @media (max-width: 1000px) {
    margin-left: 10%;
    margin-right: 10%;
  }
`;

const WhyBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const ContactUs = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-bottom: 6%;
  margin-left: 10%;
  margin-right: 10%;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const ContacLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ContacLeftBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const BottomItem = styled.p`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
  color: #1390e6;
  margin: 0;
  align-items: center;
`;

const ContacRight = styled.div`
  width: 50%;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const Text1 = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #1390e6;
`;

const Text2 = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 48px;
  line-height: 120%;
`;

const Text3 = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
`;

const Text4 = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
`;

const Text5 = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 20px;
  line-height: 36px;
`;

const Name = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100% - 10px);
`;

const Email = styled.div`
  width: calc(100% - 10px);
`;

const PhoneNumber = styled.div`
  width: calc(100% - 10px);
`;

const MessageBox = styled(TextArea)`
  width: 100%;
  padding-left: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
`;

const PointsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Points = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

const Enterprise: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const phoneInputRef = useRef<InputRef>(null);
  const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA;
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);

  if (!recaptchaKey) {
    throw new Error("REACT_APP_GOOGLE_RECAPTCHA is not defined");
  }

  const handleRecaptchaVerify = (token: string | null) => {
    setRecaptchaToken(token);
  };

  const onFinish = async (values: any) => {
    if (!recaptchaToken) {
      message.error("Please complete the reCAPTCHA verification.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`https://formsubmit.co/${CONTACT_EMAIL}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...values,
          recaptchaToken,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error status: ${response.status}`);
      }

      message.success("Form submitted successfully!");
      form.resetFields();
    } catch (error) {
      if (error instanceof TypeError) {
        message.error("Network error occurred. Please check your internet connection.");
      } else {
        message.error("Failed to submit form, please try again.");
      }
      console.error("Failed to submit form:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container>
      <Hero>
        <Header>
          Experiences That Move Teams, <br />
          Clients, and Culture
        </Header>
        <SmallText>
          At Evendy for Enterprise, we don&apos;t just make events. We co-create business moments
          <br />
          that drive alignment, loyalty, visibility and transformation without the chaos.
        </SmallText>
        <GetStarted>
          Get Started <Arrow />
        </GetStarted>
      </Hero>
      <About>
        <AboutLeft>
          <SectionHeader>About Evendy for Enterprise</SectionHeader>
          <SectionText>
            Some business moments ask for more than logistics. They ask for clarity, emotional
            <br /> precision, and the kind of calm coordination that reflects on teams.
            <br />
            Whether you&apos;re building a stronger team, launching something new, or turning
            <br /> appreciation into advocacy, we help you deliver experiences that aren&apos;t just seen —<br /> they
            are felt.
          </SectionText>
          <GetStarted2>
            Get Started <Arrow />
          </GetStarted2>
        </AboutLeft>
        <AboutRight>
          <img src={AboutImg} alt="About Evendy" />
        </AboutRight>
      </About>
      <Whatwe>
        <WhatweContent>
          <SectionHeader>What we Design</SectionHeader>
          <WhatweBottom>
            <SectionText>
              Not just packages, We build strategic formats for
              <br /> business-critical moments.
            </SectionText>
          </WhatweBottom>

          <CardContainer>
            <Card>
              <img src={Alligned} alt="Alligned" width="36" height="36" />
              <CardText>
                Aligned leadership around
                <br /> renewed visions
              </CardText>
              <WatermarkContainer>
                <Watermark1 />
              </WatermarkContainer>
            </Card>
            <Card>
              <img src={Celebrate} alt="Alligned" width="36" height="36" />
              <CardText>
                Celebrating clients in
                <br /> ways they won&apos;t forget
              </CardText>
              <WatermarkContainer>
                <Watermark2 />
              </WatermarkContainer>
            </Card>
            <Card>
              <img src={Shake} alt="Alligned" width="36" height="36" />
              <CardText>
                Launch brands with clarity,
                <br /> confidence and credibility
              </CardText>
              <WatermarkContainer>
                <Watermark3 />
              </WatermarkContainer>
            </Card>
          </CardContainer>
          <CardContainer2>
            <Card>
              <img src={Growth} alt="Alligned" width="36" height="36" />
              <CardText>
                Internal trust and team growth
                <br /> through culture-forward on/
                <br />
                offsites
              </CardText>
              <WatermarkContainer>
                <Watermark4 />
              </WatermarkContainer>
            </Card>
            <Card>
              <img src={Loyalty} alt="Alligned" width="36" height="36" />
              <CardText>
                Loyalty among audience,
                <br /> partners and employees
              </CardText>
              <WatermarkContainer>
                <Watermark5 />
              </WatermarkContainer>
            </Card>
          </CardContainer2>
        </WhatweContent>
      </Whatwe>
      <Whowe>
        <WhoweLeft>
          {" "}
          <img src={Workbest} alt="About Evendy" />
        </WhoweLeft>
        <WhoweRight>
          <SectionHeader>Who we work best with</SectionHeader>
          <SectionText>
            We partner with visionary teams and leaders ready to turn company gatherings into
            <br />
            powerful business moments—where purpose meets precision, and every detail
            <br /> drives real impact.
          </SectionText>
          <PointsContainer>
            <Points>
              <PointIcon />
              <SectionText>HR and People teams focused on connection and culture</SectionText>
            </Points>
            <Points>
              <PointIcon />
              <SectionText>Marketing and brand leads looking to spark visibility or loyalty</SectionText>
            </Points>
            <Points>
              <PointIcon />
              <SectionText>Executive teams shaping vision and buy-in</SectionText>
            </Points>
            <Points>
              <PointIcon />
              <SectionText>Community and creator brands scaling with intention</SectionText>
            </Points>
          </PointsContainer>
        </WhoweRight>
      </Whowe>
      <WhyIt>
        <WhyItContent>
          <SectionHeader>Why It Works</SectionHeader>
          <WhyBottom>
            <SectionText>
              Because events aren&apos;t just about what happens in the room.
              <br />
              They&apos;re about how people feel after they leave—and what they do next.
            </SectionText>
            <Text5>
              We partner with you to ensure your next event doesn&apos;t just happen. It moves something forward.
            </Text5>
          </WhyBottom>
        </WhyItContent>
      </WhyIt>
      <ContactUs>
        <ContacLeft>
          <Text1>Contact us</Text1>
          <Text2>
            Ready to Create
            <br /> Something Impactful?
          </Text2>
          <Text3>
            Got a date, a milestone, or just an idea? Let’s shape it together.
            <br />
            No pressure. No pitch. Just shared clarity.
          </Text3>
          <ContacLeftBottom>
            <BottomItem>
              <Call />
              business@evendy.co
            </BottomItem>
            <BottomItem>
              <Mail />
              Book a 20-min intro call
            </BottomItem>
          </ContacLeftBottom>
        </ContacLeft>
        <ContacRight>
          <Form
            layout="vertical"
            form={form}
            name="register"
            scrollToFirstError
            requiredMark={false}
            onFinish={onFinish}
          >
            <Name>
              <Form.Item
                label="Name"
                style={{ width: "47.5%" }}
                name="firstName"
                rules={[{ required: true, message: "Please input your First name!" }]}
              >
                <Input placeholder="e.g John" style={{ fontSize: "14px", color: "#9C9C9C", paddingLeft: "10px" }} />
              </Form.Item>
              <Form.Item
                label="Company Name"
                style={{ width: "47.5%" }}
                name="lastName"
                rules={[{ required: true, message: "Please input your Last name!" }]}
              >
                <Input placeholder="e.g Evendy" style={{ fontSize: "14px", color: "#9C9C9C", paddingLeft: "10px" }} />
              </Form.Item>
            </Name>

            <Name>
              <Form.Item
                label="Phone Number"
                style={{ width: "47.5%" }}
                name="phone"
                rules={[
                  { required: true, message: "Please input your phone number!" },
                  {
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error("Phone number is required"));
                      }
                      if (!/^\d{11}$/.test(value)) {
                        return Promise.reject(new Error("Phone number must be exactly 11 digits"));
                      }
                      if (!/^0/.test(value)) {
                        return Promise.reject(new Error("Phone number must start with a 0"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  ref={phoneInputRef}
                  placeholder="e.g 08061234567"
                  style={{ fontSize: "14px", color: "#9C9C9C", paddingLeft: "10px" }}
                />
              </Form.Item>
              <Form.Item
                label="Email"
                style={{ width: "47.5%" }}
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "Please enter a valid email!",
                  },
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input
                  placeholder="e.g example@email.com"
                  style={{ fontSize: "14px", color: "#9C9C9C", paddingLeft: "10px" }}
                />
              </Form.Item>
            </Name>

            <Form.Item
              label="Message"
              name="message"
              rules={[{ required: true, message: "Please input your Message!" }]}
            >
              <MessageBox placeholder="Leave us a message" autoSize={{ minRows: 4, maxRows: 6 }} />
            </Form.Item>

            <Form.Item>
              <ReCAPTCHA sitekey={recaptchaKey} onChange={handleRecaptchaVerify} />
            </Form.Item>

            <Form.Item>
              <SubmitButton form={form} loading={loading}>
                Submit
              </SubmitButton>
            </Form.Item>
          </Form>
        </ContacRight>
      </ContactUs>
    </Container>
  );
};

export default Enterprise;
